/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_General_Created_ByInputs */



/**
* | output |
* | --- |
* | "Created By" |
*
* @param {Options_General_Created_ByInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_general_created_by = /** @type {((inputs?: Options_General_Created_ByInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_General_Created_ByInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créé par")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellt von")
	if (locale === "it") return /** @type {LocalizedString} */ ("Creato da")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создано пользователем")
	if (locale === "es") return /** @type {LocalizedString} */ ("Creado por")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建者")
	if (locale === "ja") return /** @type {LocalizedString} */ ("作成者")
	if (locale === "hi") return /** @type {LocalizedString} */ ("के द्वारा बनाई गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criado por")
	return /** @type {LocalizedString} */ ("Created By")
});